import { useQuery } from "@tanstack/react-query";
import { Agent } from "@/model";
import agentRepository from "@/repository/agentRepository";
import { agentQueryKeys } from "./keys";


const getData = async () => {
    const res = await agentRepository.find(0, 10, true);
    return res.data?.data?.content || [];
};

export const useRecentAgents = () => {
    return useQuery<Agent[]>({
        queryKey: agentQueryKeys.recent(),
        queryFn: async () => getData(),
        retry: false
    });
};
